/* eslint-disable camelcase -- snake_case fields match the ES index / API response shape */
export function normalizeTrackSearchResult (item) {
  /*
   * Make catalogue item search results (tracks and sfx) from the search index
   * like API-retrieved objects. This more closely models the database fields.
   */
  const {
    object_pk, artist_pk, artist_slug, artist_name, waveform_pk, waveform_data, full_mix_pk, instrumental_version_pk
  } = item

  const artist = {
    pk: artist_pk,
    name: artist_name,
    slug: artist_slug
  }

  const waveform = {
    pk: waveform_pk,
    data: waveform_data
  }

  // Now delete old attributes from item and add new ones.
  delete item.object_pk
  delete item.artist_pk
  delete item.artist_slug
  delete item.artist_name
  delete item.waveform_pk
  delete item.waveform_data

  item.pk = object_pk
  item.full_mix = full_mix_pk
  item.instrumental_version = instrumental_version_pk
  item.artist = artist
  item.waveform = waveform
  item.item_type = 'track'
  return item
}

export function normalizePseItemSearchResult (item) {
  /*
   * Make PSE SFX search results like API-retrieved objects.
   * This means we may have field names that don't really make sense in the context
   * of sfx, but are consistent with the rest of the catalogue and allow us to
   * make progress.
   */
  const libraryArtwork = item.libraryArtwork.find(
    artwork => artwork.format === 'png' && artwork.width < 100
  )
  const shortDescription = `${item.category}, ${item.subCategory}, ${item.description.split(',')[0]}`
  return {
    description: item.description,
    shortDescription,
    artworkUrl: libraryArtwork.url,
    category: item.category,
    subCategory: item.subCategory,
    previewUrl: item.previewUrl,
    item_type: 'sfx',
    waveformDataUrl: item.waveformDataUrl,
    // Make things play nice:
    pk: item.id,
    duration: item.durationSeconds,
    display_title: item.description,
    cover_thumbnail: libraryArtwork.url,
    artist: {
      name: item.artist
    }
  }
}

export function convertSearchArtistToCatalogueArtist (artist) {
  const { artist_pk } = artist
  delete artist.artist_pk
  artist.pk = artist_pk

  return artist
}

export function convertSearchPlaylistToCataloguePlaylist (playlist) {
  const { playlist_pk } = playlist
  delete playlist.playlist_pk
  playlist.pk = playlist_pk

  return playlist
}

// Where "browse songs" links go.
export function browseMusicRoute () {
  return { name: 'ai-track-search' }
}
